// @flow

import _ from 'lodash';
import React, { type ComponentType } from 'react';

import { CompaniesIntroPromo } from '@zapier/auth';
import { HideFooter } from '@zapier/common-components';

import EducationPromo from 'app/login/components/EducationPromo';
import LoginFormWrapperContainer from 'app/login/components/LoginFormWrapperContainer';
import PlatformLogin from 'app/login/components/PlatformLogin';
import PlatformPromoSignUp from 'app/login/components/PlatformPromoSignUp';
import SignUpPromo from 'app/login/components/SignUpPromo';
import SplitLoginPageWrapperContainer from 'app/login/components/SplitLoginPageWrapperContainer';
import TeamMemberPromo from 'app/login/components/TeamMemberPromo';
import matchesMediaQuery from 'app/common/components/matchesMediaQuery';

const promos = {
  edu: EducationPromo,
  login: CompaniesIntroPromo,
  'sign-up': SignUpPromo,
  teamMember: TeamMemberPromo,
  platformSignUp: PlatformPromoSignUp,
  platformLogin: PlatformLogin,
};

type LoginAppProps = {
  query: {
    promo: $Keys<typeof promos>,
    reauth?: boolean,
  },
  matchesMediaQuery: {
    isTwoColumn: string,
  },
  route: {
    FormComponent: ComponentType<any>,
    promo: $Keys<typeof promos>,
    promoClass?: string,
  },
};

const LoginApp = (props: LoginAppProps) => {
  const childProps = _.omit(props, 'matchesMediaQuery');
  const { FormComponent, promo, promoClass } = props.route;
  const { query } = props;
  const { isTwoColumn } = props.matchesMediaQuery;

  const finalPromo = query.promo || promo;

  const MatchedPromo = promos[finalPromo];
  const hidePromos = query.reauth;

  return (
    <HideFooter>
      <SplitLoginPageWrapperContainer
        Promo={isTwoColumn && !hidePromos ? MatchedPromo : null}
        promoClass={promoClass}
        {...childProps}
      >
        <LoginFormWrapperContainer
          FormComponent={FormComponent}
          Promo={!isTwoColumn && !hidePromos ? MatchedPromo : null}
          {...childProps}
        />
      </SplitLoginPageWrapperContainer>
    </HideFooter>
  );
};

export default matchesMediaQuery({
  isTwoColumn: '(min-width: 750px)',
})(LoginApp);
